// @flow

import React from 'react';
import { Wrapper } from './styled';

// Themes
// 'blue-gradient' | 'red-gradient'
// 'filter' | 'filter-active' | 'cancel'
// 'blue' | 'red' | 'green' | 'white' | 'transparent'
type Props = {
  children: React$Node,
  onClick?: Function,
  theme?: string,
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  thin?: boolean,
  pill?: boolean,
  loading?: boolean,
  disabled?: boolean,
  type?: 'button' | 'submit' | 'reset',
  form?: string,
  className?: string,
  margin?: string
};

export const Button = (props: Props) => {
  return (
    <Wrapper
      theme={props.theme}
      size={props.size}
      thin={props.thin}
      pill={props.pill}
      margin={props.margin}
      onClick={(...args) => {
        if (props.disabled || props.loading || typeof props.onClick !== 'function') {
          return;
        }

        props.onClick(...args);
      }}
      disabled={props.loading || props.disabled}
      loading={props.loading}
      className={props.className}
      type={props.type || 'button'}
      form={props.form || undefined}>
      {props.children}
    </Wrapper>
  );
};

export default Button;